<div class="login-container">
  <div class="login-background">
    <div class="shape"></div>
    <div class="shape"></div>
  </div>
  
  <div class="login-content">
    <div class="logo-container">
      <img src="assets/images/nri-logo-white.png"  alt="Logo" class="logo">
    </div>
    
    <div class="login-card">
      <div class="login-header">
        <h2>Forgot Password</h2>
        <p>Enter your email to receive a password reset link</p>
      </div>
      
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="login-form">
        <div class="form-group">
          <app-text-input 
          label="Email Address" 
          placeholder="Enter your email" 
          [control]="getControl('email')">
      </app-text-input>
        </div>

        <div class="form-group">
          <button 
            type="submit" 
            class="btn btn-primary w-100"
            [disabled]="forgotPasswordForm.invalid || isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            {{ isLoading ? 'Sending...' : 'Send Reset Link' }}
          </button>
        </div>
      </form>
      
      <div class="login-footer text-center mt-4">
        <p>Remember your password? <a [routerLink]="['/login']">Sign In</a></p>
      </div>
    </div>
  </div>
</div>
